import React from "react";
import PropTypes from "prop-types";

import { Row, Col, Panel } from "react-bootstrap";

import { orderBy } from "lodash";

import { formatDate } from "../../../helpers/date";

const CallNoteList = ({ call, isMobile }) => {
  let callNotesView = (
    <div className="content-wrapper vertical-center sm" style={{ margin: 0 }}>
      <h4>No notes available</h4>
    </div>
  );

  if (call) {
    const { notes } = call;

    if (notes && notes.length) {
      callNotesView = (
        <Row>
          {orderBy(notes, "modified_on", "desc").map((note) => {
            const timestamp = formatDate(
              note.created_on,
              !isMobile ? "MM/dd/yyyy hh:mm a" : "MM/dd/yyyy"
            );

            return (
              <Panel bsStyle="info" key={note.id} className="note-panel">
                <Panel.Heading>
                  <Row>
                    <Col md={6} xs={6}>
                      <h5>{note.title}</h5>
                    </Col>
                    <Col md={6} xs={6}>
                      <p>
                        <span style={{ marginRight: "10px" }}>
                          {note.created_by.split("@")[0]}
                        </span>
                        •<em style={{ marginLeft: "10px" }}>{timestamp}</em>
                      </p>
                    </Col>
                  </Row>
                </Panel.Heading>
                <Panel.Body>
                  <Col md={11} xs={10}>
                    <blockquote>
                      <div dangerouslySetInnerHTML={{ __html: note.note }} />
                    </blockquote>
                  </Col>
                </Panel.Body>
              </Panel>
            );
          })}
        </Row>
      );
    }
  }

  return <div>{callNotesView}</div>;
};

CallNoteList.propTypes = {
  call: PropTypes.object,
  isMobile: PropTypes.bool
};

export default CallNoteList;
